const VERSION = '2.9.3';
export function getVersionString() {
    return VERSION;
}
